//global constants
export const PAGESIZE = 20;

//color
export const darkModeStepperNav = "#272727";
export const darkModeStepperContent = "#1A1A1A";
export const darkModeBackgroud = "var(--dark-mode-bg)";
export const statusBadgeDefault = "var(--status-badge-default)";
export const darkModeBackgroudInputs = "var(--dark-mode-bg-input)";

//
export const CACHE_KEY_TICKETS = "tickets";
export const CACHE_KEY_USERS = "users";
export const CACHE_KEY_USERS_BYFIRSTLASTNAME = "usersbyfirstlastname";
export const CACHE_KEY_TICKETFINANTIALTYPE_BYFIRSTLASTNAME =
  "ticketfinantialtypebyfirstlastname";
export const CACHE_KEY_RECURRINGTICKETS = "recurringtickets";
//settings

//general
export const CACHE_KEY_COMPANYNEWS = "companynews";
export const CACHE_KEY_COMPANY = "company";
export const CACHE_KEY_DOCUMENTTEMPLATE = "documenttemplate";

export const CACHE_KEY_STATUSES = "statuses";
export const CACHE_KEY_CATEGORIES = "categories";
export const CACHE_KEY_CONTRACTORS = "contractors";
export const CACHE_KEY_CUSTOMERS = "customer";
export const CACHE_KEY_CUSTOMERSBYCOMPANYID = "customersbycompanyid";
export const CACHE_KEY_CUSTOMERSBYCOMPLOCID = "customersbycomplocid";
export const CACHE_KEY_INTERVENTIONTYPES = "interventionTypes";
export const CACHE_KEY_LOCATIONS = "locations";
export const CACHE_KEY_LOCATIONBYCOMPID = "locationsbycompanyid";
export const CACHE_KEY_PRIORITIES = "priorities";
export const CACHE_KEY_DEPARTMENTS = "departments";
export const CACHE_KEY_INCIDENT = "incidents";
export const CACHE_KEY_USERWITHPASSWORDFORGET = "userwithpasswordforget";
export const CACHE_KEY_GETBYSTATUSES = "getbystatuses";
export const CACHE_KEY_GETOPENTICKETSBYMONTH = "getopenticketsbymonth";
export const CACHE_KEY_GETTICKETCLOSEDTODAY = "getticketclosedtoday";
export const CACHE_KEY_GETCLOSEDTICKETSBYMONTH = "getclosedticketsbymonth";
export const CACHE_KEY_GETBYASSIGNEDTO = "getbyassignedto";
export const CACHE_KEY_TICKETFEEDBACK = "ticketfeedback";
export const CACHE_KEY_TICKETNOTIFICATION = "ticketnotification";
export const CACHE_KEY_ROLES = "roles";

//start assets
export const CACHE_KEY_ASSETLOCATIONS = "assetlocations";
export const CACHE_KEY_ASSETCATEGORIES = "assetcategories";
export const CACHE_KEY_ASSETTYPES = "assettypes";
export const CACHE_KEY_ASSETS = "assets";
export const CACHE_KEY_ASSETSTATUSES = "assetstatuses";
export const CACHE_KEY_ASSETDEPARTMENTS = "assetdepartments";
export const CACHE_KEY_ASSETACTIONS = "assetactions";
export const CACHE_KEY_ASSETACTIONTYPES = "assetactiontypes";

//end assets

//get user global filters
export const CACHE_KEY_GETALLUSERGLOBALFILTER = "getalluserglobalfilter";
export const CACHE_KEY_GETUSERFIELDSTOFILTER = "getuserfieldtofilter";

//start procurements
export const CACHE_KEY_VENDORS = "vendors";
export const CACHE_KEY_VENDORSTATUSES = "vendorstatuses";
export const CACHE_KEY_PURCHASEORDERS = "purchaseorders";
export const CACHE_KEY_PURCHASEORDERTYPES = "purchaseordertypes";
export const CACHE_KEY_APPROVALPERSONS = "approvalpersons";
export const CACHE_KEY_QUOTATIONREQUESTS = "quotationrequests";
export const CACHE_KEY_APPROVALREQUESTS = "approvalrequests";
export const CACHE_KEY_APPROVALREQUESTSBYPURCHASEORDERID =
  "approvalrequestsbypurchaseorderid";
export const CACHE_KEY_EVALUATIONCRITERIA = "evaluationcriteria";
export const CACHE_KEY_PURCHASEREQUESTS = "purchaserequests";
export const CACHE_KEY_REQUESTFORPROPOSAL = "requestforproposal";
export const CACHE_KEY_REQUESTFORQUOTATION = "requestforquotation";
